// ================= AdminDashboard.jsx =================
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';

const AdminSidebar = () => {
  const navigate = useNavigate();
  const items = [
   { name: "Dashboard", path: "/AdminDashboard" },
    { name: "Professeurs", path: "/TeachersPage" },
    { name: "Classes", path: "/classes" },
    { name: "Cours", path: "/courses" },
    { name: "Etudiant", path: "/student" },
    { name: "Examens", path: "/exams" },
    { name: "Salles", path: "/rooms" },
        { name: "bulletins", path: "/bulletins" },
    { name: "Notifications", path: "/notifications" },
    { name: "Gestion Utilisateurs", path: "/administrator" },
    { name: "Profil", path: "/profile" },
    { name: "Déconnexion", path: "/logout" },
  ];

  return (
    <div style={styles.sidebar}>
      {items.map((item, idx) => (
        <div key={idx} style={styles.sidebarItem} onClick={() => navigate(item.path)}>
          {item.name}
        </div>
      ))}
    </div>
  );
};

const AdminDashboard = ({ user }) => {
  const [stats, setStats] = useState({ students: 0, professors: 0, exams: 0 });
  const [recentExams, setRecentExams] = useState([]);

  useEffect(() => {
    // Simulation fetch data
    setStats({ students: 120, professors: 15, exams: 8 });
    setRecentExams([
      { name: 'Mathématiques', date: '2026-04-10' },
      { name: 'Physique', date: '2026-04-12' },
    ]);
  }, []);

  return (
    <div style={styles.container}>
      <Toaster position="top-right" />
      <AdminSidebar />
      <div style={styles.mainContent}>
        <h1>Bienvenue, {user?.fullname}</h1>

        <div style={styles.statsBox}>
          <div style={styles.statCard}>Étudiants<br/><strong>{stats.students}</strong></div>
          <div style={styles.statCard}>Professeurs<br/><strong>{stats.professors}</strong></div>
          <div style={styles.statCard}>Examens<br/><strong>{stats.exams}</strong></div>
        </div>

        <h2>Examens récents</h2>
        <table style={styles.table}>
          <thead>
            <tr>
              <th>Nom</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {recentExams.map((exam, idx) => (
              <tr key={idx}>
                <td>{exam.name}</td>
                <td>{exam.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminDashboard;

const styles = {
  container: { display: 'flex', minHeight: '100vh', fontFamily: 'Segoe UI, sans-serif' },
  sidebar: { width: '220px', backgroundColor: '#0f172a', color: '#fff', padding: '20px', display: 'flex', flexDirection: 'column' },
  sidebarItem: { padding: '12px', marginBottom: '10px', borderRadius: '8px', cursor: 'pointer', backgroundColor: '#1e3a8a' },
  mainContent: { flex: 1, padding: '30px', backgroundColor: '#f8fafc' },
  statsBox: { display: 'flex', gap: '20px', marginBottom: '20px' },
  statCard: { flex:1, background:'#2563eb', color:'#fff', padding:'20px', borderRadius:'10px', textAlign:'center', fontSize:'18px' },
  table: { width: '100%', borderCollapse: 'collapse', marginTop: '15px', background:'#fff' },
};
